import request from '@/utils/requestFile'

export function fuelRecordToExcel(data) {
  return request({
    url: 'api/file/fuelRecordToExcel',
    method: 'post',
    data: data
  })
}

export function oilHistoryRecordToExcel(data) {
  return request({
    url: 'api/file/oilHistoryRecordToExcel',
    method: 'post',
    data: data
  })
}

export function rechargeRecordToExcel(data) {
  return request({
    url: 'api/file/rechargeRecordToExcel',
    method: 'post',
    data: data
  })
}

export function refundRecordToExcel(data) {
  return request({
    url: 'api/file/refundRecordToExcel',
    method: 'post',
    data: data
  })
}

export function amountRecordToExcel(data) {
  return request({
    url: 'api/file/amountRecordToExcel',
    method: 'post',
    data: data
  })
}

export function pointRecordToExcel(data) {
  return request({
    url: 'api/file/pointRecordToExcel',
    method: 'post',
    data: data
  })
}
